import React from 'react'
import { UseFormRegister } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Box, Input } from '@node-space/ui-components'
import {
  UpdateBeneficiaryFormErrors,
  UpdateBeneficiaryFormPayload,
  UpdateBeneficiaryFormPayloadKeys,
} from 'types/beneficiaries'

interface EditBeneficiaryFormProps {
  isBusiness: boolean
  alias: string
  businessName: string
  firstName: string
  lastName: string
  errors: UpdateBeneficiaryFormErrors
  handleOnchange: (field: UpdateBeneficiaryFormPayloadKeys, value: string) => void
  register: UseFormRegister<UpdateBeneficiaryFormPayload>
}

export const EditBeneficiaryForm = ({
  isBusiness,
  alias,
  businessName,
  firstName,
  lastName,
  errors,
  handleOnchange,
  register,
}: EditBeneficiaryFormProps) => {
  const { t } = useTranslation()

  return (
    <Box paddingB={24}>
      <>
        {isBusiness && (
          <Box paddingB={16}>
            <Input
              {...register('businessName')}
              label={t('businessName')}
              placeholder={t('enterBusinessName')}
              inputMode="text"
              name="businessName"
              test-id="business-name"
              errorText={errors?.businessName?.message}
              error={!!errors?.businessName}
              value={businessName}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                handleOnchange('businessName', e.target.value)
              }
            />
          </Box>
        )}

        {!isBusiness && (
          <>
            <Box paddingB={16}>
              <Input
                {...register('firstName')}
                label={t('formFields.firstName')}
                placeholder={t('enterName')}
                inputMode="text"
                name="firstName"
                test-id="first-name"
                errorText={errors?.firstName?.message}
                error={!!errors?.firstName}
                value={firstName}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  handleOnchange('firstName', e.target.value)
                }
              />
            </Box>
            <Box paddingB={16}>
              <Input
                {...register('lastName')}
                label={t('formFields.lastName')}
                placeholder={t('enterLastName')}
                inputMode="text"
                name="lastName"
                test-id="last-name"
                errorText={errors?.lastName?.message}
                error={!!errors?.lastName}
                value={lastName}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  handleOnchange('lastName', e.target.value)
                }
              />
            </Box>
          </>
        )}
      </>

      <Input
        testId="update-beneficiary-name-input"
        {...register('alias')}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          handleOnchange('alias', e.target.value)
        }
        label={t('manageBeneficiaries.beneficiaryDescription')}
        name="beneficiaryName"
        value={alias}
        error={!!errors?.alias}
        errorText={errors?.alias?.message}
      />
    </Box>
  )
}
